// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsletter {
    border: 1px solid;
    background-color: white;
    padding: 15px;
}

.newsletter-success {
    border: 1px solid rgb(36, 192, 128) !important;
    color: rgb(36, 192, 128);
    background-color: white;
    padding: 15px;
}

.newsletter-error {
    border: 1px solid #a21236 !important;
    color: #a21236;
    background-color: white;
    padding: 15px;
}

.newsletter-button-spacer {
    margin-bottom: 10px;
    margin-right: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/components/newsletter.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,8CAA8C;IAC9C,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".newsletter {\n    border: 1px solid;\n    background-color: white;\n    padding: 15px;\n}\n\n.newsletter-success {\n    border: 1px solid rgb(36, 192, 128) !important;\n    color: rgb(36, 192, 128);\n    background-color: white;\n    padding: 15px;\n}\n\n.newsletter-error {\n    border: 1px solid #a21236 !important;\n    color: #a21236;\n    background-color: white;\n    padding: 15px;\n}\n\n.newsletter-button-spacer {\n    margin-bottom: 10px;\n    margin-right: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
